// extracted by mini-css-extract-plugin
export default {"section":"AboutSection_section__m6Tr5","container":"AboutSection_container__bEyP0","left":"AboutSection_left__7tYjd","right":"AboutSection_right__Wh4iM"};